import { TimelineConnector, TimelineConnectorProps } from "@mui/lab";

interface CampaignTimelineConnectorProps extends TimelineConnectorProps {}

export function CampaignTimelineConnector({}: CampaignTimelineConnectorProps) {
  return <TimelineConnector style={{ backgroundColor: "#EBEFF7", width: 1 }} />;
}
